import React, { useState } from "react";
import { MenuList, MenuItem } from "@mui/material";
import {
  Business,
  BusinessCenterSharp,
  Menu as MenuIcon,
} from "@mui/icons-material";

import Btn from "../../components/Custom/Btn";

// Reports
import StockLevel from "../Masters/StockLevel";
import OrganizationProfile from "../Masters/OranizationProfile";
import LeadApprovals from "../Masters/LeadApprovals";
import LeadDocuments from "../Masters/LeadDocuments";
import Report1 from "../Report1";
import Scheme from "../Masters/Scheme";
import Product from "../Masters/Product";
import Category from "../Masters/Category";
import Tax from "../Masters/Tax";
import Region from "../Masters/Region";
import Country from "../Masters/Country";
import State from "../Masters/State";
import Beat from "../Masters/Beat";
import City from "../Masters/City";
import Currency from "../Masters/Currency";
import Grams from "../Masters/Grams";
import SKU from "../Masters/SKU";
import SubCategory from "../Masters/SubCategory";
import Price from "../Masters/Price";
import Branch from "../Masters/Branch";
import FareChart from "../Masters/FareChart";
import Team from "../Masters/Team";
import VehicleDriver from "../Masters/VehicleDriver";
import Holidays from "../Masters/Holidays";
import LeaveType from "../Masters/LeaveType";
import Users from "../Masters/Users/Users";
import Targets from "../Masters/Targets";
import MainCategory from "../Masters/MainCategory";
import Vehicle from "../Masters/Vehicle";
import Driver from "../Masters/Driver";
import Customer from "../Masters/Customer";
import CentralZone from "../Masters/CentralZone";
import RegionalZone from "../Masters/RegionalZone";
import Area from "../Masters/Area";
import NewCategory from "../Masters/NewCategory";
import Expenses from "../Masters/Expenses";
import BusinessCategory from "../Masters/BusinessCategory";
import SalesWiseCategory from "../Masters/SalesWiseCategory";
import District from "../Masters/District";
import ProductTypeCategory from "../Masters/ProductTypeCategory";
import Leaves from "../Masters/Leaves";
import AssignBeat from "./AssignBeat";

import ReportEmployeeLeaves from "../../components/Reports/ReportEmployeeLeaves";
import UserLogReport from "../../components/Reports/UserLogReport";

import { CONFIG } from "../../common/config";
import { LABELS } from "../../common/lables";

import "./dashboard.css";
import "./styles/reports.css";
import "./styles/datatables.min.css";
import "devextreme/dist/css/dx.light.css";

//../../assets/images/reports/employeeleavesreport.png
const employeeLeavesReport = require("../../assets/images/reports/employeeleavesreport.png");
const chart1 = require("assets/images/reports/chart1.png");
const chartResourceHistogram = require("assets/images/reports/Resource_Histogram.png");
const chartResourceTable = require("assets/images/reports/Resource_Table.png");
const chartManHoursPlan = require("assets/images/reports/Man_Hours_Distribution.png");
const chartProgressCurve = require("assets/images/reports/Progress_S_Curve.png");
const chartProjectCashFlow = require("assets/images/reports/Project_Cashflow.png");
const chartProgressStatus = require("assets/images/reports/Project_Progress_Pie.png");
const chartProjectOverview = require("assets/images/reports/Project_Overview.png");
const chartRisksRegister = require("assets/images/reports/Risk_Register.png");
const chartEarnedValue = require("assets/images/reports/Earned_Value_Report.png");
const chartQuantitiesReport = require("assets/images/reports/Quantities_Report.png");
const chartManhoursReport = require("assets/images/reports/Manhours_Report.png");
const chartCostReport = require("assets/images/reports/Cost_Report.png");
const chartConstraintLogReport = require("assets/images/reports/Constraint_Log_Report.png");
const chartTimeSheetLog = require("assets/images/reports/Time_Sheet_Log_Report.png");
const chartApprovalLog = require("assets/images/reports/Approval_Log_Report.png");
const userLogreport = require("assets/images/reports/User_Log_Report.png");
const invoicereport = require("assets/images/reports/invoicereport.png");
const analysisReport = require("assets/images/reports/projectsreport.png");

const Masters = (props: any = {}) => {
  const [dashMenu, setDashMenu] = useState(LABELS.HOME);
  const { childRef, userInfo, setPageMenu } = props;
  const setMenu = () => {
    setDashMenu(LABELS.HOME);
  };
  childRef.setMenu = setMenu;

  let menuUserLog = false;
  if (userInfo.role.id === CONFIG.USER_ROLES.Admin) {
    menuUserLog = true;
  }

  return (
    <React.Fragment>
      {dashMenu == LABELS.HOME && (
        <div className="userDashboard">
          <div className="pageInfo">
            <ul className="breadcrumbs">
              <li onClick={() => setPageMenu(LABELS.HOME)}>{LABELS.HOME}</li>
              <li className="dim">{" / "}</li>
              <li className="active">{LABELS.MASTERS}</li>
            </ul>
            <h4>{LABELS.MASTERS}</h4>
          </div>

          {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.GEO_REPORT);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.GEO_REPORT}</h4>
            </MenuItem> */}

          <h4 className="subHeadings">{LABELS.GEOGRAPHY}</h4>
          <MenuList dense className="dashboardMenuWrap">
            {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.COUNTRY);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.COUNTRY}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CURRENCY);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.CURRENCY}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.STATE);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.STATE}</h4>
            </MenuItem> */}
            {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CENTRAL_ZONES);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.CENTRAL_ZONES}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.DISTRICT);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.DISTRICT}</h4>
            </MenuItem> */}
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.REGION);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  <path d="M1743 5005 c-76 -21 -123 -47 -184 -103 -105 -97 -155 -221 -146 -362 5 -80 32 -166 72 -225 14 -20 25 -38 25 -40 0 -2 -28 -20 -62 -41 -35 -20 -105 -66 -156 -101 l-93 -64 -43 35 c-222 182 -554 102 -680 -164 -29 -61 -31 -72 -31 -185 0 -140 13 -178 102 -302 l53 -74 -26 -52 c-96 -189 -177 -450 -221 -712 -25 -150 -24 -474 1 -630 39 -243 95 -422 200 -640 532 -1098 1846 -1556 2941 -1026 644 311 1089 896 1215 1595 48 267 47 515 -5 822 -22 132 -73 352 -94 407 -9 22 -2 36 56 112 97 129 118 180 118 290 0 80 -3 97 -32 157 -98 207 -347 281 -531 157 l-43 -29 -62 56 c-322 292 -769 513 -1217 601 -122 24 -158 27 -370 27 l-235 1 -1 67 c-3 124 -74 270 -165 339 -114 87 -258 118 -386 84z m199 -119 c106 -32 193 -125 223 -241 19 -72 13 -139 -20 -211 -21 -49 -281 -404 -294 -404 -10 1 -267 352 -292 400 -20 38 -24 60 -24 135 0 106 19 157 86 230 84 91 206 126 321 91z m908 -512 c128 -22 315 -74 430 -119 105 -41 342 -156 377 -183 l23 -17 -90 -154 c-60 -104 -92 -170 -96 -199 -10 -65 17 -140 66 -190 49 -48 87 -68 174 -86 36 -7 77 -21 91 -30 53 -35 73 -121 42 -182 -8 -16 -66 -74 -129 -129 -267 -234 -278 -250 -278 -408 0 -119 15 -155 100 -236 52 -50 59 -61 64 -106 16 -134 46 -189 127 -235 38 -21 59 -25 157 -28 190 -7 289 25 376 118 25 26 58 74 74 106 38 75 65 90 173 99 85 7 87 7 94 -16 10 -29 -2 -237 -21 -369 -73 -510 -345 -990 -747 -1318 -422 -345 -982 -516 -1518 -462 -723 73 -1350 508 -1673 1161 -138 278 -216 611 -216 918 0 148 35 411 57 431 4 4 63 24 129 45 97 30 131 36 165 31 64 -10 119 -45 159 -101 48 -69 258 -278 315 -314 26 -17 76 -40 111 -51 46 -16 73 -32 101 -63 36 -39 44 -59 92 -232 29 -105 63 -211 76 -237 13 -26 86 -130 163 -230 76 -101 146 -195 155 -209 10 -15 34 -128 61 -282 49 -285 57 -306 133 -342 75 -36 158 -19 222 46 43 42 58 74 75 157 18 87 31 112 102 198 73 90 83 111 137 288 26 82 56 164 69 182 13 19 68 69 123 111 164 125 207 165 226 207 40 89 22 145 -89 277 -108 129 -152 185 -152 194 0 4 25 40 54 81 83 113 100 166 101 299 0 107 -1 112 -37 188 -47 98 -118 171 -213 218 -67 33 -74 34 -185 34 -109 0 -119 -2 -183 -32 -89 -42 -173 -126 -215 -214 -18 -37 -32 -73 -32 -80 0 -11 -26 -14 -122 -14 l-123 0 -116 -59 c-171 -86 -191 -79 -309 110 -88 140 -97 179 -56 248 29 50 91 86 147 86 20 0 86 -7 148 -15 174 -23 257 7 346 124 61 80 76 86 241 86 139 0 141 0 190 30 62 39 177 181 205 255 15 38 21 79 21 131 1 111 -16 144 -231 448 l-45 64 145 -6 c79 -3 187 -13 239 -23z m-387 -174 c71 -102 136 -201 144 -220 18 -40 19 -133 3 -175 -18 -46 -118 -174 -153 -195 -28 -17 -48 -19 -167 -17 -133 2 -136 2 -189 -28 -30 -16 -68 -47 -85 -69 -97 -123 -117 -131 -278 -109 -185 24 -268 7 -351 -74 -76 -73 -106 -184 -74 -276 22 -64 163 -282 206 -318 46 -38 130 -63 185 -55 22 3 91 31 152 62 103 52 116 55 180 55 103 0 120 -9 128 -68 11 -82 68 -179 238 -403 158 -208 164 -215 198 -215 33 0 40 7 115 107 44 59 83 106 86 105 18 -6 219 -261 219 -278 0 -38 -20 -59 -168 -173 -170 -132 -197 -166 -241 -306 -16 -52 -40 -127 -52 -167 -18 -56 -37 -90 -86 -150 -76 -93 -108 -155 -127 -245 -16 -80 -35 -112 -73 -125 -28 -10 -66 -3 -77 15 -3 5 -23 117 -45 249 -23 132 -48 256 -56 277 -8 20 -85 129 -170 242 -85 113 -159 213 -164 223 -6 10 -33 101 -61 202 -28 101 -60 203 -71 226 -29 60 -117 138 -181 159 -29 9 -70 25 -91 36 -50 25 -249 218 -281 272 -55 94 -165 162 -278 172 -53 5 -78 1 -159 -25 -53 -17 -98 -31 -101 -31 -12 0 61 212 116 334 l26 58 82 -108 c124 -164 105 -171 326 124 205 273 223 308 230 447 4 79 1 100 -22 165 -14 41 -24 75 -23 76 1 1 52 35 112 76 117 78 201 125 208 118 2 -3 49 -66 104 -140 56 -74 110 -143 121 -154 41 -36 60 -19 240 221 94 126 176 240 183 255 11 26 34 37 73 34 13 -1 61 -61 149 -186z m-1483 -132 c84 -24 177 -120 205 -212 22 -73 19 -161 -8 -226 -13 -31 -84 -136 -161 -238 l-138 -184 -142 191 c-83 111 -149 210 -159 238 -40 112 -12 252 69 342 86 96 202 127 334 89z m2925 -164 c39 -29 98 -79 133 -111 l63 -58 -22 -55 c-31 -76 -31 -193 -1 -270 13 -33 79 -132 165 -245 126 -169 145 -190 173 -193 26 -3 37 3 63 34 17 21 33 35 36 32 15 -15 95 -425 95 -489 0 -26 -2 -27 -82 -33 -46 -4 -99 -11 -118 -16 -59 -16 -114 -64 -150 -132 -39 -76 -81 -123 -135 -151 -32 -17 -63 -22 -161 -25 -172 -6 -199 10 -215 125 -14 107 -32 143 -105 212 l-66 62 4 94 c2 76 7 97 23 115 11 13 93 88 182 167 186 166 215 207 215 311 0 140 -84 234 -239 266 -39 8 -83 22 -98 32 -30 20 -55 63 -55 96 0 13 39 90 86 171 l86 148 27 -17 c14 -9 58 -40 96 -70z m626 -132 c118 -61 172 -219 113 -334 -18 -36 -216 -307 -224 -307 -3 0 -52 64 -110 142 -135 184 -156 241 -126 341 48 158 207 231 347 158z m-1793 -683 c67 -33 118 -86 154 -158 19 -38 23 -62 23 -141 0 -83 -3 -101 -25 -141 -26 -47 -281 -398 -290 -398 -13 -1 -287 382 -302 420 -24 63 -23 175 2 243 12 29 39 75 61 100 67 76 131 104 240 105 65 1 84 -3 137 -30z" />{" "}
                  <path d="M1768 4827 c-188 -53 -250 -295 -110 -435 90 -89 241 -97 346 -17 45 34 86 114 93 179 18 178 -155 321 -329 273z m147 -131 c116 -76 63 -256 -75 -256 -148 0 -191 194 -59 263 39 21 96 18 134 -7z" />{" "}
                  <path d="M752 3994 c-88 -44 -141 -127 -142 -223 0 -83 19 -130 75 -188 198 -204 529 18 420 283 -53 130 -224 192 -353 128z m213 -136 c44 -47 52 -95 26 -153 -16 -37 -29 -50 -67 -66 -62 -28 -106 -19 -156 31 -33 33 -38 44 -38 84 0 96 56 150 149 143 47 -3 59 -9 86 -39z" />{" "}
                  <path d="M4314 3751 c-70 -32 -124 -117 -124 -197 0 -97 75 -191 169 -214 175 -42 327 142 252 305 -50 108 -186 156 -297 106z m167 -130 c40 -40 40 -89 0 -133 -24 -27 -36 -33 -71 -33 -35 0 -47 6 -71 33 -40 44 -40 93 0 133 23 23 38 29 71 29 33 0 48 -6 71 -29z" />{" "}
                  <path d="M2496 3045 c-99 -35 -166 -133 -166 -241 0 -77 15 -118 66 -174 93 -103 223 -117 340 -37 166 113 138 362 -50 448 -49 22 -135 24 -190 4z m147 -116 c125 -65 100 -244 -37 -266 -45 -7 -115 26 -139 66 -21 36 -22 102 -2 142 31 58 121 87 178 58z" />{" "}
                </g>
              </svg>
              <h4>{LABELS.REGION}</h4>
            </MenuItem>
            {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.REGIONAL_ZONES);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.REGIONAL_ZONES}</h4>
            </MenuItem> */}
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CITY);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  <path d="M1743 5005 c-76 -21 -123 -47 -184 -103 -105 -97 -155 -221 -146 -362 5 -80 32 -166 72 -225 14 -20 25 -38 25 -40 0 -2 -28 -20 -62 -41 -35 -20 -105 -66 -156 -101 l-93 -64 -43 35 c-222 182 -554 102 -680 -164 -29 -61 -31 -72 -31 -185 0 -140 13 -178 102 -302 l53 -74 -26 -52 c-96 -189 -177 -450 -221 -712 -25 -150 -24 -474 1 -630 39 -243 95 -422 200 -640 532 -1098 1846 -1556 2941 -1026 644 311 1089 896 1215 1595 48 267 47 515 -5 822 -22 132 -73 352 -94 407 -9 22 -2 36 56 112 97 129 118 180 118 290 0 80 -3 97 -32 157 -98 207 -347 281 -531 157 l-43 -29 -62 56 c-322 292 -769 513 -1217 601 -122 24 -158 27 -370 27 l-235 1 -1 67 c-3 124 -74 270 -165 339 -114 87 -258 118 -386 84z m199 -119 c106 -32 193 -125 223 -241 19 -72 13 -139 -20 -211 -21 -49 -281 -404 -294 -404 -10 1 -267 352 -292 400 -20 38 -24 60 -24 135 0 106 19 157 86 230 84 91 206 126 321 91z m908 -512 c128 -22 315 -74 430 -119 105 -41 342 -156 377 -183 l23 -17 -90 -154 c-60 -104 -92 -170 -96 -199 -10 -65 17 -140 66 -190 49 -48 87 -68 174 -86 36 -7 77 -21 91 -30 53 -35 73 -121 42 -182 -8 -16 -66 -74 -129 -129 -267 -234 -278 -250 -278 -408 0 -119 15 -155 100 -236 52 -50 59 -61 64 -106 16 -134 46 -189 127 -235 38 -21 59 -25 157 -28 190 -7 289 25 376 118 25 26 58 74 74 106 38 75 65 90 173 99 85 7 87 7 94 -16 10 -29 -2 -237 -21 -369 -73 -510 -345 -990 -747 -1318 -422 -345 -982 -516 -1518 -462 -723 73 -1350 508 -1673 1161 -138 278 -216 611 -216 918 0 148 35 411 57 431 4 4 63 24 129 45 97 30 131 36 165 31 64 -10 119 -45 159 -101 48 -69 258 -278 315 -314 26 -17 76 -40 111 -51 46 -16 73 -32 101 -63 36 -39 44 -59 92 -232 29 -105 63 -211 76 -237 13 -26 86 -130 163 -230 76 -101 146 -195 155 -209 10 -15 34 -128 61 -282 49 -285 57 -306 133 -342 75 -36 158 -19 222 46 43 42 58 74 75 157 18 87 31 112 102 198 73 90 83 111 137 288 26 82 56 164 69 182 13 19 68 69 123 111 164 125 207 165 226 207 40 89 22 145 -89 277 -108 129 -152 185 -152 194 0 4 25 40 54 81 83 113 100 166 101 299 0 107 -1 112 -37 188 -47 98 -118 171 -213 218 -67 33 -74 34 -185 34 -109 0 -119 -2 -183 -32 -89 -42 -173 -126 -215 -214 -18 -37 -32 -73 -32 -80 0 -11 -26 -14 -122 -14 l-123 0 -116 -59 c-171 -86 -191 -79 -309 110 -88 140 -97 179 -56 248 29 50 91 86 147 86 20 0 86 -7 148 -15 174 -23 257 7 346 124 61 80 76 86 241 86 139 0 141 0 190 30 62 39 177 181 205 255 15 38 21 79 21 131 1 111 -16 144 -231 448 l-45 64 145 -6 c79 -3 187 -13 239 -23z m-387 -174 c71 -102 136 -201 144 -220 18 -40 19 -133 3 -175 -18 -46 -118 -174 -153 -195 -28 -17 -48 -19 -167 -17 -133 2 -136 2 -189 -28 -30 -16 -68 -47 -85 -69 -97 -123 -117 -131 -278 -109 -185 24 -268 7 -351 -74 -76 -73 -106 -184 -74 -276 22 -64 163 -282 206 -318 46 -38 130 -63 185 -55 22 3 91 31 152 62 103 52 116 55 180 55 103 0 120 -9 128 -68 11 -82 68 -179 238 -403 158 -208 164 -215 198 -215 33 0 40 7 115 107 44 59 83 106 86 105 18 -6 219 -261 219 -278 0 -38 -20 -59 -168 -173 -170 -132 -197 -166 -241 -306 -16 -52 -40 -127 -52 -167 -18 -56 -37 -90 -86 -150 -76 -93 -108 -155 -127 -245 -16 -80 -35 -112 -73 -125 -28 -10 -66 -3 -77 15 -3 5 -23 117 -45 249 -23 132 -48 256 -56 277 -8 20 -85 129 -170 242 -85 113 -159 213 -164 223 -6 10 -33 101 -61 202 -28 101 -60 203 -71 226 -29 60 -117 138 -181 159 -29 9 -70 25 -91 36 -50 25 -249 218 -281 272 -55 94 -165 162 -278 172 -53 5 -78 1 -159 -25 -53 -17 -98 -31 -101 -31 -12 0 61 212 116 334 l26 58 82 -108 c124 -164 105 -171 326 124 205 273 223 308 230 447 4 79 1 100 -22 165 -14 41 -24 75 -23 76 1 1 52 35 112 76 117 78 201 125 208 118 2 -3 49 -66 104 -140 56 -74 110 -143 121 -154 41 -36 60 -19 240 221 94 126 176 240 183 255 11 26 34 37 73 34 13 -1 61 -61 149 -186z m-1483 -132 c84 -24 177 -120 205 -212 22 -73 19 -161 -8 -226 -13 -31 -84 -136 -161 -238 l-138 -184 -142 191 c-83 111 -149 210 -159 238 -40 112 -12 252 69 342 86 96 202 127 334 89z m2925 -164 c39 -29 98 -79 133 -111 l63 -58 -22 -55 c-31 -76 -31 -193 -1 -270 13 -33 79 -132 165 -245 126 -169 145 -190 173 -193 26 -3 37 3 63 34 17 21 33 35 36 32 15 -15 95 -425 95 -489 0 -26 -2 -27 -82 -33 -46 -4 -99 -11 -118 -16 -59 -16 -114 -64 -150 -132 -39 -76 -81 -123 -135 -151 -32 -17 -63 -22 -161 -25 -172 -6 -199 10 -215 125 -14 107 -32 143 -105 212 l-66 62 4 94 c2 76 7 97 23 115 11 13 93 88 182 167 186 166 215 207 215 311 0 140 -84 234 -239 266 -39 8 -83 22 -98 32 -30 20 -55 63 -55 96 0 13 39 90 86 171 l86 148 27 -17 c14 -9 58 -40 96 -70z m626 -132 c118 -61 172 -219 113 -334 -18 -36 -216 -307 -224 -307 -3 0 -52 64 -110 142 -135 184 -156 241 -126 341 48 158 207 231 347 158z m-1793 -683 c67 -33 118 -86 154 -158 19 -38 23 -62 23 -141 0 -83 -3 -101 -25 -141 -26 -47 -281 -398 -290 -398 -13 -1 -287 382 -302 420 -24 63 -23 175 2 243 12 29 39 75 61 100 67 76 131 104 240 105 65 1 84 -3 137 -30z" />{" "}
                  <path d="M1768 4827 c-188 -53 -250 -295 -110 -435 90 -89 241 -97 346 -17 45 34 86 114 93 179 18 178 -155 321 -329 273z m147 -131 c116 -76 63 -256 -75 -256 -148 0 -191 194 -59 263 39 21 96 18 134 -7z" />{" "}
                  <path d="M752 3994 c-88 -44 -141 -127 -142 -223 0 -83 19 -130 75 -188 198 -204 529 18 420 283 -53 130 -224 192 -353 128z m213 -136 c44 -47 52 -95 26 -153 -16 -37 -29 -50 -67 -66 -62 -28 -106 -19 -156 31 -33 33 -38 44 -38 84 0 96 56 150 149 143 47 -3 59 -9 86 -39z" />{" "}
                  <path d="M4314 3751 c-70 -32 -124 -117 -124 -197 0 -97 75 -191 169 -214 175 -42 327 142 252 305 -50 108 -186 156 -297 106z m167 -130 c40 -40 40 -89 0 -133 -24 -27 -36 -33 -71 -33 -35 0 -47 6 -71 33 -40 44 -40 93 0 133 23 23 38 29 71 29 33 0 48 -6 71 -29z" />{" "}
                  <path d="M2496 3045 c-99 -35 -166 -133 -166 -241 0 -77 15 -118 66 -174 93 -103 223 -117 340 -37 166 113 138 362 -50 448 -49 22 -135 24 -190 4z m147 -116 c125 -65 100 -244 -37 -266 -45 -7 -115 26 -139 66 -21 36 -22 102 -2 142 31 58 121 87 178 58z" />{" "}
                </g>
              </svg>
              <h4>{LABELS.CITY}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.AREA);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  <path d="M1743 5005 c-76 -21 -123 -47 -184 -103 -105 -97 -155 -221 -146 -362 5 -80 32 -166 72 -225 14 -20 25 -38 25 -40 0 -2 -28 -20 -62 -41 -35 -20 -105 -66 -156 -101 l-93 -64 -43 35 c-222 182 -554 102 -680 -164 -29 -61 -31 -72 -31 -185 0 -140 13 -178 102 -302 l53 -74 -26 -52 c-96 -189 -177 -450 -221 -712 -25 -150 -24 -474 1 -630 39 -243 95 -422 200 -640 532 -1098 1846 -1556 2941 -1026 644 311 1089 896 1215 1595 48 267 47 515 -5 822 -22 132 -73 352 -94 407 -9 22 -2 36 56 112 97 129 118 180 118 290 0 80 -3 97 -32 157 -98 207 -347 281 -531 157 l-43 -29 -62 56 c-322 292 -769 513 -1217 601 -122 24 -158 27 -370 27 l-235 1 -1 67 c-3 124 -74 270 -165 339 -114 87 -258 118 -386 84z m199 -119 c106 -32 193 -125 223 -241 19 -72 13 -139 -20 -211 -21 -49 -281 -404 -294 -404 -10 1 -267 352 -292 400 -20 38 -24 60 -24 135 0 106 19 157 86 230 84 91 206 126 321 91z m908 -512 c128 -22 315 -74 430 -119 105 -41 342 -156 377 -183 l23 -17 -90 -154 c-60 -104 -92 -170 -96 -199 -10 -65 17 -140 66 -190 49 -48 87 -68 174 -86 36 -7 77 -21 91 -30 53 -35 73 -121 42 -182 -8 -16 -66 -74 -129 -129 -267 -234 -278 -250 -278 -408 0 -119 15 -155 100 -236 52 -50 59 -61 64 -106 16 -134 46 -189 127 -235 38 -21 59 -25 157 -28 190 -7 289 25 376 118 25 26 58 74 74 106 38 75 65 90 173 99 85 7 87 7 94 -16 10 -29 -2 -237 -21 -369 -73 -510 -345 -990 -747 -1318 -422 -345 -982 -516 -1518 -462 -723 73 -1350 508 -1673 1161 -138 278 -216 611 -216 918 0 148 35 411 57 431 4 4 63 24 129 45 97 30 131 36 165 31 64 -10 119 -45 159 -101 48 -69 258 -278 315 -314 26 -17 76 -40 111 -51 46 -16 73 -32 101 -63 36 -39 44 -59 92 -232 29 -105 63 -211 76 -237 13 -26 86 -130 163 -230 76 -101 146 -195 155 -209 10 -15 34 -128 61 -282 49 -285 57 -306 133 -342 75 -36 158 -19 222 46 43 42 58 74 75 157 18 87 31 112 102 198 73 90 83 111 137 288 26 82 56 164 69 182 13 19 68 69 123 111 164 125 207 165 226 207 40 89 22 145 -89 277 -108 129 -152 185 -152 194 0 4 25 40 54 81 83 113 100 166 101 299 0 107 -1 112 -37 188 -47 98 -118 171 -213 218 -67 33 -74 34 -185 34 -109 0 -119 -2 -183 -32 -89 -42 -173 -126 -215 -214 -18 -37 -32 -73 -32 -80 0 -11 -26 -14 -122 -14 l-123 0 -116 -59 c-171 -86 -191 -79 -309 110 -88 140 -97 179 -56 248 29 50 91 86 147 86 20 0 86 -7 148 -15 174 -23 257 7 346 124 61 80 76 86 241 86 139 0 141 0 190 30 62 39 177 181 205 255 15 38 21 79 21 131 1 111 -16 144 -231 448 l-45 64 145 -6 c79 -3 187 -13 239 -23z m-387 -174 c71 -102 136 -201 144 -220 18 -40 19 -133 3 -175 -18 -46 -118 -174 -153 -195 -28 -17 -48 -19 -167 -17 -133 2 -136 2 -189 -28 -30 -16 -68 -47 -85 -69 -97 -123 -117 -131 -278 -109 -185 24 -268 7 -351 -74 -76 -73 -106 -184 -74 -276 22 -64 163 -282 206 -318 46 -38 130 -63 185 -55 22 3 91 31 152 62 103 52 116 55 180 55 103 0 120 -9 128 -68 11 -82 68 -179 238 -403 158 -208 164 -215 198 -215 33 0 40 7 115 107 44 59 83 106 86 105 18 -6 219 -261 219 -278 0 -38 -20 -59 -168 -173 -170 -132 -197 -166 -241 -306 -16 -52 -40 -127 -52 -167 -18 -56 -37 -90 -86 -150 -76 -93 -108 -155 -127 -245 -16 -80 -35 -112 -73 -125 -28 -10 -66 -3 -77 15 -3 5 -23 117 -45 249 -23 132 -48 256 -56 277 -8 20 -85 129 -170 242 -85 113 -159 213 -164 223 -6 10 -33 101 -61 202 -28 101 -60 203 -71 226 -29 60 -117 138 -181 159 -29 9 -70 25 -91 36 -50 25 -249 218 -281 272 -55 94 -165 162 -278 172 -53 5 -78 1 -159 -25 -53 -17 -98 -31 -101 -31 -12 0 61 212 116 334 l26 58 82 -108 c124 -164 105 -171 326 124 205 273 223 308 230 447 4 79 1 100 -22 165 -14 41 -24 75 -23 76 1 1 52 35 112 76 117 78 201 125 208 118 2 -3 49 -66 104 -140 56 -74 110 -143 121 -154 41 -36 60 -19 240 221 94 126 176 240 183 255 11 26 34 37 73 34 13 -1 61 -61 149 -186z m-1483 -132 c84 -24 177 -120 205 -212 22 -73 19 -161 -8 -226 -13 -31 -84 -136 -161 -238 l-138 -184 -142 191 c-83 111 -149 210 -159 238 -40 112 -12 252 69 342 86 96 202 127 334 89z m2925 -164 c39 -29 98 -79 133 -111 l63 -58 -22 -55 c-31 -76 -31 -193 -1 -270 13 -33 79 -132 165 -245 126 -169 145 -190 173 -193 26 -3 37 3 63 34 17 21 33 35 36 32 15 -15 95 -425 95 -489 0 -26 -2 -27 -82 -33 -46 -4 -99 -11 -118 -16 -59 -16 -114 -64 -150 -132 -39 -76 -81 -123 -135 -151 -32 -17 -63 -22 -161 -25 -172 -6 -199 10 -215 125 -14 107 -32 143 -105 212 l-66 62 4 94 c2 76 7 97 23 115 11 13 93 88 182 167 186 166 215 207 215 311 0 140 -84 234 -239 266 -39 8 -83 22 -98 32 -30 20 -55 63 -55 96 0 13 39 90 86 171 l86 148 27 -17 c14 -9 58 -40 96 -70z m626 -132 c118 -61 172 -219 113 -334 -18 -36 -216 -307 -224 -307 -3 0 -52 64 -110 142 -135 184 -156 241 -126 341 48 158 207 231 347 158z m-1793 -683 c67 -33 118 -86 154 -158 19 -38 23 -62 23 -141 0 -83 -3 -101 -25 -141 -26 -47 -281 -398 -290 -398 -13 -1 -287 382 -302 420 -24 63 -23 175 2 243 12 29 39 75 61 100 67 76 131 104 240 105 65 1 84 -3 137 -30z" />{" "}
                  <path d="M1768 4827 c-188 -53 -250 -295 -110 -435 90 -89 241 -97 346 -17 45 34 86 114 93 179 18 178 -155 321 -329 273z m147 -131 c116 -76 63 -256 -75 -256 -148 0 -191 194 -59 263 39 21 96 18 134 -7z" />{" "}
                  <path d="M752 3994 c-88 -44 -141 -127 -142 -223 0 -83 19 -130 75 -188 198 -204 529 18 420 283 -53 130 -224 192 -353 128z m213 -136 c44 -47 52 -95 26 -153 -16 -37 -29 -50 -67 -66 -62 -28 -106 -19 -156 31 -33 33 -38 44 -38 84 0 96 56 150 149 143 47 -3 59 -9 86 -39z" />{" "}
                  <path d="M4314 3751 c-70 -32 -124 -117 -124 -197 0 -97 75 -191 169 -214 175 -42 327 142 252 305 -50 108 -186 156 -297 106z m167 -130 c40 -40 40 -89 0 -133 -24 -27 -36 -33 -71 -33 -35 0 -47 6 -71 33 -40 44 -40 93 0 133 23 23 38 29 71 29 33 0 48 -6 71 -29z" />{" "}
                  <path d="M2496 3045 c-99 -35 -166 -133 -166 -241 0 -77 15 -118 66 -174 93 -103 223 -117 340 -37 166 113 138 362 -50 448 -49 22 -135 24 -190 4z m147 -116 c125 -65 100 -244 -37 -266 -45 -7 -115 26 -139 66 -21 36 -22 102 -2 142 31 58 121 87 178 58z" />{" "}
                </g>
              </svg>
              <h4>{LABELS.AREA}</h4>
            </MenuItem>
            {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.ORGANIZATION_PROFILE);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.ORGANIZATION_PROFILE}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.BRANCH);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.BRANCH}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.ASSIGN_BEAT);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.ASSIGN_BEAT}</h4>
            </MenuItem> */}
          </MenuList>

          {/* <h4 className="subHeadings">{LABELS.CUSTOMERS}</h4>
          <MenuList dense className="dashboardMenuWrap">
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.LEAD_APPROVALS);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.LEAD_APPROVALS}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.LEAD_DOCUMENTS);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.LEAD_DOCUMENTS}</h4>
            </MenuItem>
          </MenuList> */}
          {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CUSTOMER);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.CUSTOMER}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.CUSTOMER_TYPE);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.CUSTOMER_TYPE}</h4>
            </MenuItem>
          </MenuList> */}

          <h4 className="subHeadings">{LABELS.PRODUCTS}</h4>
          <MenuList dense className="dashboardMenuWrap">
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.GRAMS);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.GRAMS}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.TAX);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.TAX}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.MAIN_CATEGORY);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.MAIN_CATEGORY}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.NEW_CATEGORY);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.NEW_CATEGORY}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.SUB_CATEGORY);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.SUB_CATEGORY}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.TYPE_CATEGORY);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.TYPE_CATEGORY}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.PRODUCT);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.PRODUCT}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.SKU);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.SKU}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.PRICE);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M1215 4785 l-25 -24 0 -459 0 -459 26 -24 c23 -21 36 -24 125 -27 l99 -4 0 -844 0 -844 -72 0 c-171 0 -381 -52 -526 -131 -41 -21 -75 -39 -78 -39 -2 0 -4 103 -4 229 l0 229 -31 26 -31 27 -325 -3 -325 -3 -24 -28 -24 -28 0 -1003 0 -1003 25 -27 24 -26 331 0 331 0 24 25 25 24 0 229 0 230 108 -54 c59 -30 153 -66 207 -81 l100 -28 839 -3 c737 -2 849 -1 924 13 48 9 388 97 757 196 368 99 789 212 935 251 282 75 340 99 397 161 117 131 120 328 5 458 -32 37 -125 91 -174 103 l-28 6 0 970 0 970 90 0 c111 0 145 14 160 68 8 25 10 177 8 470 l-3 434 -28 24 -28 24 -1895 0 -1895 0 -24 -25z m3703 -482 l-3 -338 -1777 -3 -1778 -2 0 340 0 340 1780 0 1780 0 -2 -337z m-258 -1492 l0 -979 -22 -6 c-13 -3 -232 -62 -488 -131 l-465 -125 -15 22 c-92 135 -114 147 -451 238 -151 40 -431 116 -624 168 l-350 95 -317 5 -318 4 0 844 0 844 1525 0 1525 0 0 -979z m-4070 -1431 l0 -890 -210 0 -210 0 0 890 0 890 210 0 210 0 0 -890z m2234 382 c329 -90 611 -169 627 -177 34 -18 68 -64 80 -110 26 -95 -60 -205 -161 -205 -17 0 -199 45 -404 100 -204 55 -382 100 -394 100 -11 0 -33 -11 -48 -24 -35 -29 -39 -86 -8 -116 13 -13 137 -52 394 -122 334 -90 384 -102 460 -102 73 -1 93 3 141 27 90 44 167 140 184 230 7 33 11 37 59 51 28 8 265 72 526 141 510 136 540 141 598 98 15 -11 37 -37 50 -59 44 -76 12 -188 -66 -228 -15 -7 -207 -62 -427 -121 -220 -59 -641 -171 -937 -250 -295 -79 -565 -149 -600 -155 -43 -7 -323 -10 -888 -8 l-825 3 -75 23 c-92 28 -238 99 -302 147 l-48 35 0 339 0 339 68 45 c84 56 149 88 232 116 139 47 185 50 690 47 l475 -2 599 -162z" />{" "}
                  <path d="M2655 3595 c-32 -31 -32 -75 -1 -112 l24 -28 429 -3 c235 -2 443 0 461 3 69 13 98 97 49 143 -23 22 -25 22 -481 22 l-457 0 -24 -25z" />{" "}
                </g>{" "}
              </svg>
              <h4>{LABELS.PRICE}</h4>
            </MenuItem>
          </MenuList>

          <h4 className="subHeadings">{LABELS.TEAM}</h4>
          <MenuList dense className="dashboardMenuWrap">
            {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.EXPENSES);
              }}
            >
              <img src={chart1} />
              <h4>{LABELS.EXPENSES}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.FARE_CHART);
              }}
            >
              <img src={chart1} />
              <h4>{LABELS.FARE_CHART}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.HOLIDAYS);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.HOLIDAYS}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.TEAM);
              }}
            >
              <img src={chartResourceHistogram} />
              <h4>{LABELS.TEAM}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.GPT_BASE);
              }}
            >
              <img src={chartResourceHistogram} />
              <h4>{LABELS.GPT_BASE}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.SCHEME);
              }}
            >
              <img src={chartResourceHistogram} />
              <h4>{LABELS.SCHEME}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.TARGETS);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.TARGETS}</h4>
            </MenuItem> */}
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.VEHICLE);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M2466 5110 c-111 -28 -224 -123 -275 -230 -23 -49 -26 -67 -25 -160 0 -58 3 -113 5 -122 3 -13 -122 -90 -581 -355 l-585 -339 -50 41 c-111 89 -249 117 -382 76 -276 -85 -374 -435 -181 -646 55 -60 109 -96 182 -121 l46 -16 0 -678 0 -678 -46 -16 c-114 -39 -216 -133 -255 -234 -107 -280 105 -570 401 -549 90 6 149 29 228 88 45 34 58 40 76 31 11 -5 275 -157 586 -336 443 -257 564 -331 561 -344 -2 -9 -5 -64 -5 -122 -1 -93 2 -111 25 -160 40 -85 108 -154 197 -197 72 -36 81 -38 172 -38 91 0 100 2 172 38 88 43 152 107 195 195 25 51 28 68 28 157 0 55 -3 109 -8 121 -7 19 18 35 250 169 142 82 401 231 575 332 174 101 324 186 332 189 8 3 37 -11 68 -35 78 -59 139 -82 227 -88 174 -12 318 74 395 236 28 60 31 75 31 161 -1 120 -25 187 -97 265 -55 60 -109 96 -182 121 l-46 16 0 678 0 678 46 16 c114 39 216 133 255 234 106 279 -103 567 -400 550 -88 -5 -178 -42 -245 -100 l-39 -34 -331 191 c-182 105 -447 258 -589 340 -232 134 -257 150 -250 169 5 12 8 66 8 121 0 87 -4 107 -26 155 -65 137 -199 228 -345 235 -44 3 -96 0 -118 -5z m218 -174 c89 -52 131 -133 124 -240 -9 -145 -144 -253 -288 -230 -64 10 -140 62 -175 118 -24 40 -30 62 -33 120 -3 62 0 78 25 125 31 60 80 105 139 127 58 21 153 13 208 -20z m-409 -506 c27 -30 107 -78 158 -96 l45 -15 4 -159 c4 -181 11 -200 78 -200 64 0 69 14 72 195 l3 158 68 28 c38 15 91 46 118 69 l49 41 585 -338 586 -338 -8 -50 c-10 -64 -10 -118 0 -176 l8 -47 -118 -67 c-146 -84 -163 -99 -163 -141 0 -36 37 -74 73 -74 11 0 79 34 151 76 81 47 135 73 142 67 6 -4 33 -25 60 -45 41 -31 88 -54 152 -74 10 -3 12 -145 10 -684 l-3 -681 -50 -17 c-52 -18 -101 -48 -147 -90 l-27 -25 -134 77 c-74 42 -145 76 -156 76 -31 0 -71 -44 -71 -78 0 -37 20 -54 163 -136 l118 -68 -8 -47 c-10 -58 -10 -112 0 -176 l8 -50 -585 -338 -586 -337 -54 44 c-30 25 -82 54 -115 66 l-59 22 -4 158 c-4 181 -11 200 -78 200 -67 0 -74 -19 -78 -200 l-4 -158 -59 -22 c-33 -12 -85 -41 -114 -66 l-55 -44 -586 337 -585 338 8 50 c10 64 10 118 0 176 l-8 47 118 68 c143 82 163 99 163 136 0 35 -40 78 -72 78 -13 0 -81 -34 -153 -76 -79 -46 -134 -72 -141 -67 -6 4 -33 25 -60 45 -41 32 -94 57 -151 74 -19 5 -19 1363 0 1368 62 20 110 43 151 74 27 20 54 41 60 45 7 6 61 -20 142 -67 72 -42 140 -76 151 -76 36 0 73 38 73 74 0 42 -17 57 -163 141 l-118 67 8 47 c10 58 10 112 0 176 l-8 50 248 142 c136 79 399 230 583 337 184 108 338 195 341 196 3 0 14 -9 24 -20z m-1501 -552 c65 -20 140 -100 161 -171 36 -125 -26 -251 -150 -302 -47 -20 -141 -21 -187 -2 -153 64 -205 257 -105 389 64 83 175 117 281 86z m3767 -16 c159 -83 186 -294 54 -411 -52 -45 -96 -62 -164 -62 -99 -1 -178 45 -223 127 -48 90 -44 186 13 268 68 100 211 135 320 78z m-3727 -2161 c105 -55 154 -173 121 -288 -13 -46 -28 -69 -68 -108 -84 -82 -189 -99 -288 -47 -120 62 -172 204 -118 322 64 141 217 194 353 121z m3712 14 c49 -20 105 -76 130 -130 57 -122 7 -263 -115 -327 -99 -52 -204 -35 -288 47 -90 88 -104 199 -39 307 64 107 195 150 312 103z m-1845 -1091 c85 -47 129 -122 129 -221 -1 -266 -364 -349 -476 -108 -66 141 9 308 160 355 51 15 130 4 187 -26z" />{" "}
                  <path d="M1933 3766 c-234 -57 -391 -285 -356 -517 13 -80 56 -179 101 -230 l31 -36 -55 -38 c-86 -59 -160 -148 -209 -250 -49 -103 -66 -167 -68 -261 -2 -58 1 -68 22 -85 49 -40 121 -7 121 57 1 56 30 170 61 233 39 79 133 175 210 215 l56 30 60 -17 c33 -10 95 -17 139 -17 l80 0 12 -32 c6 -18 30 -56 51 -85 l40 -52 -66 -48 c-157 -115 -262 -316 -263 -500 0 -73 20 -103 69 -103 53 0 72 27 81 115 9 85 32 158 73 227 35 59 133 150 196 183 54 27 54 27 111 11 72 -20 188 -20 260 0 57 16 57 16 110 -11 102 -52 209 -176 245 -284 8 -27 20 -84 24 -127 7 -62 14 -82 31 -96 30 -24 75 -23 101 3 20 20 21 29 16 108 -11 192 -118 377 -284 492 l-42 29 39 53 c22 28 46 67 52 85 l12 32 80 0 c44 0 106 7 139 17 l60 17 56 -30 c77 -40 171 -136 210 -215 31 -64 60 -177 61 -235 0 -62 72 -95 121 -55 21 17 24 27 22 85 -2 94 -19 158 -68 261 -49 102 -123 191 -209 250 l-55 38 31 36 c45 51 88 150 101 230 46 299 -230 572 -529 523 -144 -24 -285 -126 -345 -249 l-24 -49 -86 0 -86 0 -22 48 c-35 76 -122 162 -205 203 -109 54 -207 67 -313 41z m231 -165 c58 -25 118 -81 147 -136 24 -46 24 -46 4 -57 -11 -7 -46 -36 -78 -66 -65 -63 -122 -166 -132 -240 -3 -26 -9 -60 -12 -76 l-5 -28 -72 4 c-155 10 -274 124 -292 279 -12 103 42 226 125 283 97 67 216 81 315 37z m1049 -4 c200 -91 247 -366 87 -511 -61 -55 -116 -79 -196 -84 l-72 -4 -5 28 c-3 16 -9 50 -12 76 -10 74 -67 177 -132 240 -32 30 -67 59 -78 65 -19 11 -19 13 -3 46 72 151 256 215 411 144z m-538 -294 c70 -23 156 -110 180 -182 50 -152 -9 -310 -147 -387 -48 -26 -62 -29 -148 -29 -86 0 -100 3 -148 29 -175 97 -220 333 -91 480 93 106 213 136 354 89z" />{" "}
                  <path d="M2941 1780 c-52 -22 -67 -79 -31 -118 20 -21 30 -22 165 -22 132 0 147 2 165 20 25 25 26 71 1 101 -18 23 -26 24 -148 26 -70 2 -139 -2 -152 -7z" />{" "}
                  <path d="M1876 1758 c-37 -53 -5 -118 58 -118 37 0 76 36 76 70 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M2136 1758 c-37 -53 -5 -118 58 -118 37 0 76 36 76 70 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M2396 1758 c-9 -12 -16 -34 -16 -48 0 -44 26 -70 70 -70 30 0 43 6 59 26 12 15 21 34 21 44 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M1882 1467 c-31 -33 -29 -80 4 -106 26 -21 34 -21 674 -21 640 0 648 0 674 21 34 27 36 77 3 107 l-23 22 -655 0 -656 0 -21 -23z" />{" "}
                </g>{" "}
              </svg>{" "}
              <h4>{LABELS.VEHICLE}</h4>
            </MenuItem>

            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.USERS);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M2466 5110 c-111 -28 -224 -123 -275 -230 -23 -49 -26 -67 -25 -160 0 -58 3 -113 5 -122 3 -13 -122 -90 -581 -355 l-585 -339 -50 41 c-111 89 -249 117 -382 76 -276 -85 -374 -435 -181 -646 55 -60 109 -96 182 -121 l46 -16 0 -678 0 -678 -46 -16 c-114 -39 -216 -133 -255 -234 -107 -280 105 -570 401 -549 90 6 149 29 228 88 45 34 58 40 76 31 11 -5 275 -157 586 -336 443 -257 564 -331 561 -344 -2 -9 -5 -64 -5 -122 -1 -93 2 -111 25 -160 40 -85 108 -154 197 -197 72 -36 81 -38 172 -38 91 0 100 2 172 38 88 43 152 107 195 195 25 51 28 68 28 157 0 55 -3 109 -8 121 -7 19 18 35 250 169 142 82 401 231 575 332 174 101 324 186 332 189 8 3 37 -11 68 -35 78 -59 139 -82 227 -88 174 -12 318 74 395 236 28 60 31 75 31 161 -1 120 -25 187 -97 265 -55 60 -109 96 -182 121 l-46 16 0 678 0 678 46 16 c114 39 216 133 255 234 106 279 -103 567 -400 550 -88 -5 -178 -42 -245 -100 l-39 -34 -331 191 c-182 105 -447 258 -589 340 -232 134 -257 150 -250 169 5 12 8 66 8 121 0 87 -4 107 -26 155 -65 137 -199 228 -345 235 -44 3 -96 0 -118 -5z m218 -174 c89 -52 131 -133 124 -240 -9 -145 -144 -253 -288 -230 -64 10 -140 62 -175 118 -24 40 -30 62 -33 120 -3 62 0 78 25 125 31 60 80 105 139 127 58 21 153 13 208 -20z m-409 -506 c27 -30 107 -78 158 -96 l45 -15 4 -159 c4 -181 11 -200 78 -200 64 0 69 14 72 195 l3 158 68 28 c38 15 91 46 118 69 l49 41 585 -338 586 -338 -8 -50 c-10 -64 -10 -118 0 -176 l8 -47 -118 -67 c-146 -84 -163 -99 -163 -141 0 -36 37 -74 73 -74 11 0 79 34 151 76 81 47 135 73 142 67 6 -4 33 -25 60 -45 41 -31 88 -54 152 -74 10 -3 12 -145 10 -684 l-3 -681 -50 -17 c-52 -18 -101 -48 -147 -90 l-27 -25 -134 77 c-74 42 -145 76 -156 76 -31 0 -71 -44 -71 -78 0 -37 20 -54 163 -136 l118 -68 -8 -47 c-10 -58 -10 -112 0 -176 l8 -50 -585 -338 -586 -337 -54 44 c-30 25 -82 54 -115 66 l-59 22 -4 158 c-4 181 -11 200 -78 200 -67 0 -74 -19 -78 -200 l-4 -158 -59 -22 c-33 -12 -85 -41 -114 -66 l-55 -44 -586 337 -585 338 8 50 c10 64 10 118 0 176 l-8 47 118 68 c143 82 163 99 163 136 0 35 -40 78 -72 78 -13 0 -81 -34 -153 -76 -79 -46 -134 -72 -141 -67 -6 4 -33 25 -60 45 -41 32 -94 57 -151 74 -19 5 -19 1363 0 1368 62 20 110 43 151 74 27 20 54 41 60 45 7 6 61 -20 142 -67 72 -42 140 -76 151 -76 36 0 73 38 73 74 0 42 -17 57 -163 141 l-118 67 8 47 c10 58 10 112 0 176 l-8 50 248 142 c136 79 399 230 583 337 184 108 338 195 341 196 3 0 14 -9 24 -20z m-1501 -552 c65 -20 140 -100 161 -171 36 -125 -26 -251 -150 -302 -47 -20 -141 -21 -187 -2 -153 64 -205 257 -105 389 64 83 175 117 281 86z m3767 -16 c159 -83 186 -294 54 -411 -52 -45 -96 -62 -164 -62 -99 -1 -178 45 -223 127 -48 90 -44 186 13 268 68 100 211 135 320 78z m-3727 -2161 c105 -55 154 -173 121 -288 -13 -46 -28 -69 -68 -108 -84 -82 -189 -99 -288 -47 -120 62 -172 204 -118 322 64 141 217 194 353 121z m3712 14 c49 -20 105 -76 130 -130 57 -122 7 -263 -115 -327 -99 -52 -204 -35 -288 47 -90 88 -104 199 -39 307 64 107 195 150 312 103z m-1845 -1091 c85 -47 129 -122 129 -221 -1 -266 -364 -349 -476 -108 -66 141 9 308 160 355 51 15 130 4 187 -26z" />{" "}
                  <path d="M1933 3766 c-234 -57 -391 -285 -356 -517 13 -80 56 -179 101 -230 l31 -36 -55 -38 c-86 -59 -160 -148 -209 -250 -49 -103 -66 -167 -68 -261 -2 -58 1 -68 22 -85 49 -40 121 -7 121 57 1 56 30 170 61 233 39 79 133 175 210 215 l56 30 60 -17 c33 -10 95 -17 139 -17 l80 0 12 -32 c6 -18 30 -56 51 -85 l40 -52 -66 -48 c-157 -115 -262 -316 -263 -500 0 -73 20 -103 69 -103 53 0 72 27 81 115 9 85 32 158 73 227 35 59 133 150 196 183 54 27 54 27 111 11 72 -20 188 -20 260 0 57 16 57 16 110 -11 102 -52 209 -176 245 -284 8 -27 20 -84 24 -127 7 -62 14 -82 31 -96 30 -24 75 -23 101 3 20 20 21 29 16 108 -11 192 -118 377 -284 492 l-42 29 39 53 c22 28 46 67 52 85 l12 32 80 0 c44 0 106 7 139 17 l60 17 56 -30 c77 -40 171 -136 210 -215 31 -64 60 -177 61 -235 0 -62 72 -95 121 -55 21 17 24 27 22 85 -2 94 -19 158 -68 261 -49 102 -123 191 -209 250 l-55 38 31 36 c45 51 88 150 101 230 46 299 -230 572 -529 523 -144 -24 -285 -126 -345 -249 l-24 -49 -86 0 -86 0 -22 48 c-35 76 -122 162 -205 203 -109 54 -207 67 -313 41z m231 -165 c58 -25 118 -81 147 -136 24 -46 24 -46 4 -57 -11 -7 -46 -36 -78 -66 -65 -63 -122 -166 -132 -240 -3 -26 -9 -60 -12 -76 l-5 -28 -72 4 c-155 10 -274 124 -292 279 -12 103 42 226 125 283 97 67 216 81 315 37z m1049 -4 c200 -91 247 -366 87 -511 -61 -55 -116 -79 -196 -84 l-72 -4 -5 28 c-3 16 -9 50 -12 76 -10 74 -67 177 -132 240 -32 30 -67 59 -78 65 -19 11 -19 13 -3 46 72 151 256 215 411 144z m-538 -294 c70 -23 156 -110 180 -182 50 -152 -9 -310 -147 -387 -48 -26 -62 -29 -148 -29 -86 0 -100 3 -148 29 -175 97 -220 333 -91 480 93 106 213 136 354 89z" />{" "}
                  <path d="M2941 1780 c-52 -22 -67 -79 -31 -118 20 -21 30 -22 165 -22 132 0 147 2 165 20 25 25 26 71 1 101 -18 23 -26 24 -148 26 -70 2 -139 -2 -152 -7z" />{" "}
                  <path d="M1876 1758 c-37 -53 -5 -118 58 -118 37 0 76 36 76 70 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M2136 1758 c-37 -53 -5 -118 58 -118 37 0 76 36 76 70 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M2396 1758 c-9 -12 -16 -34 -16 -48 0 -44 26 -70 70 -70 30 0 43 6 59 26 12 15 21 34 21 44 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M1882 1467 c-31 -33 -29 -80 4 -106 26 -21 34 -21 674 -21 640 0 648 0 674 21 34 27 36 77 3 107 l-23 22 -655 0 -656 0 -21 -23z" />{" "}
                </g>{" "}
              </svg>{" "}
              <h4>{LABELS.USERS}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.DRIVER);
              }}
            >
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="60.000000pt"
                height="100.000000pt"
                viewBox="0 0 512.000000 512.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                {" "}
                <g
                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                  fill="#0078b2"
                  stroke="none"
                >
                  {" "}
                  <path d="M2466 5110 c-111 -28 -224 -123 -275 -230 -23 -49 -26 -67 -25 -160 0 -58 3 -113 5 -122 3 -13 -122 -90 -581 -355 l-585 -339 -50 41 c-111 89 -249 117 -382 76 -276 -85 -374 -435 -181 -646 55 -60 109 -96 182 -121 l46 -16 0 -678 0 -678 -46 -16 c-114 -39 -216 -133 -255 -234 -107 -280 105 -570 401 -549 90 6 149 29 228 88 45 34 58 40 76 31 11 -5 275 -157 586 -336 443 -257 564 -331 561 -344 -2 -9 -5 -64 -5 -122 -1 -93 2 -111 25 -160 40 -85 108 -154 197 -197 72 -36 81 -38 172 -38 91 0 100 2 172 38 88 43 152 107 195 195 25 51 28 68 28 157 0 55 -3 109 -8 121 -7 19 18 35 250 169 142 82 401 231 575 332 174 101 324 186 332 189 8 3 37 -11 68 -35 78 -59 139 -82 227 -88 174 -12 318 74 395 236 28 60 31 75 31 161 -1 120 -25 187 -97 265 -55 60 -109 96 -182 121 l-46 16 0 678 0 678 46 16 c114 39 216 133 255 234 106 279 -103 567 -400 550 -88 -5 -178 -42 -245 -100 l-39 -34 -331 191 c-182 105 -447 258 -589 340 -232 134 -257 150 -250 169 5 12 8 66 8 121 0 87 -4 107 -26 155 -65 137 -199 228 -345 235 -44 3 -96 0 -118 -5z m218 -174 c89 -52 131 -133 124 -240 -9 -145 -144 -253 -288 -230 -64 10 -140 62 -175 118 -24 40 -30 62 -33 120 -3 62 0 78 25 125 31 60 80 105 139 127 58 21 153 13 208 -20z m-409 -506 c27 -30 107 -78 158 -96 l45 -15 4 -159 c4 -181 11 -200 78 -200 64 0 69 14 72 195 l3 158 68 28 c38 15 91 46 118 69 l49 41 585 -338 586 -338 -8 -50 c-10 -64 -10 -118 0 -176 l8 -47 -118 -67 c-146 -84 -163 -99 -163 -141 0 -36 37 -74 73 -74 11 0 79 34 151 76 81 47 135 73 142 67 6 -4 33 -25 60 -45 41 -31 88 -54 152 -74 10 -3 12 -145 10 -684 l-3 -681 -50 -17 c-52 -18 -101 -48 -147 -90 l-27 -25 -134 77 c-74 42 -145 76 -156 76 -31 0 -71 -44 -71 -78 0 -37 20 -54 163 -136 l118 -68 -8 -47 c-10 -58 -10 -112 0 -176 l8 -50 -585 -338 -586 -337 -54 44 c-30 25 -82 54 -115 66 l-59 22 -4 158 c-4 181 -11 200 -78 200 -67 0 -74 -19 -78 -200 l-4 -158 -59 -22 c-33 -12 -85 -41 -114 -66 l-55 -44 -586 337 -585 338 8 50 c10 64 10 118 0 176 l-8 47 118 68 c143 82 163 99 163 136 0 35 -40 78 -72 78 -13 0 -81 -34 -153 -76 -79 -46 -134 -72 -141 -67 -6 4 -33 25 -60 45 -41 32 -94 57 -151 74 -19 5 -19 1363 0 1368 62 20 110 43 151 74 27 20 54 41 60 45 7 6 61 -20 142 -67 72 -42 140 -76 151 -76 36 0 73 38 73 74 0 42 -17 57 -163 141 l-118 67 8 47 c10 58 10 112 0 176 l-8 50 248 142 c136 79 399 230 583 337 184 108 338 195 341 196 3 0 14 -9 24 -20z m-1501 -552 c65 -20 140 -100 161 -171 36 -125 -26 -251 -150 -302 -47 -20 -141 -21 -187 -2 -153 64 -205 257 -105 389 64 83 175 117 281 86z m3767 -16 c159 -83 186 -294 54 -411 -52 -45 -96 -62 -164 -62 -99 -1 -178 45 -223 127 -48 90 -44 186 13 268 68 100 211 135 320 78z m-3727 -2161 c105 -55 154 -173 121 -288 -13 -46 -28 -69 -68 -108 -84 -82 -189 -99 -288 -47 -120 62 -172 204 -118 322 64 141 217 194 353 121z m3712 14 c49 -20 105 -76 130 -130 57 -122 7 -263 -115 -327 -99 -52 -204 -35 -288 47 -90 88 -104 199 -39 307 64 107 195 150 312 103z m-1845 -1091 c85 -47 129 -122 129 -221 -1 -266 -364 -349 -476 -108 -66 141 9 308 160 355 51 15 130 4 187 -26z" />{" "}
                  <path d="M1933 3766 c-234 -57 -391 -285 -356 -517 13 -80 56 -179 101 -230 l31 -36 -55 -38 c-86 -59 -160 -148 -209 -250 -49 -103 -66 -167 -68 -261 -2 -58 1 -68 22 -85 49 -40 121 -7 121 57 1 56 30 170 61 233 39 79 133 175 210 215 l56 30 60 -17 c33 -10 95 -17 139 -17 l80 0 12 -32 c6 -18 30 -56 51 -85 l40 -52 -66 -48 c-157 -115 -262 -316 -263 -500 0 -73 20 -103 69 -103 53 0 72 27 81 115 9 85 32 158 73 227 35 59 133 150 196 183 54 27 54 27 111 11 72 -20 188 -20 260 0 57 16 57 16 110 -11 102 -52 209 -176 245 -284 8 -27 20 -84 24 -127 7 -62 14 -82 31 -96 30 -24 75 -23 101 3 20 20 21 29 16 108 -11 192 -118 377 -284 492 l-42 29 39 53 c22 28 46 67 52 85 l12 32 80 0 c44 0 106 7 139 17 l60 17 56 -30 c77 -40 171 -136 210 -215 31 -64 60 -177 61 -235 0 -62 72 -95 121 -55 21 17 24 27 22 85 -2 94 -19 158 -68 261 -49 102 -123 191 -209 250 l-55 38 31 36 c45 51 88 150 101 230 46 299 -230 572 -529 523 -144 -24 -285 -126 -345 -249 l-24 -49 -86 0 -86 0 -22 48 c-35 76 -122 162 -205 203 -109 54 -207 67 -313 41z m231 -165 c58 -25 118 -81 147 -136 24 -46 24 -46 4 -57 -11 -7 -46 -36 -78 -66 -65 -63 -122 -166 -132 -240 -3 -26 -9 -60 -12 -76 l-5 -28 -72 4 c-155 10 -274 124 -292 279 -12 103 42 226 125 283 97 67 216 81 315 37z m1049 -4 c200 -91 247 -366 87 -511 -61 -55 -116 -79 -196 -84 l-72 -4 -5 28 c-3 16 -9 50 -12 76 -10 74 -67 177 -132 240 -32 30 -67 59 -78 65 -19 11 -19 13 -3 46 72 151 256 215 411 144z m-538 -294 c70 -23 156 -110 180 -182 50 -152 -9 -310 -147 -387 -48 -26 -62 -29 -148 -29 -86 0 -100 3 -148 29 -175 97 -220 333 -91 480 93 106 213 136 354 89z" />{" "}
                  <path d="M2941 1780 c-52 -22 -67 -79 -31 -118 20 -21 30 -22 165 -22 132 0 147 2 165 20 25 25 26 71 1 101 -18 23 -26 24 -148 26 -70 2 -139 -2 -152 -7z" />{" "}
                  <path d="M1876 1758 c-37 -53 -5 -118 58 -118 37 0 76 36 76 70 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M2136 1758 c-37 -53 -5 -118 58 -118 37 0 76 36 76 70 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M2396 1758 c-9 -12 -16 -34 -16 -48 0 -44 26 -70 70 -70 30 0 43 6 59 26 12 15 21 34 21 44 0 10 -9 29 -21 44 -27 35 -90 37 -113 4z" />{" "}
                  <path d="M1882 1467 c-31 -33 -29 -80 4 -106 26 -21 34 -21 674 -21 640 0 648 0 674 21 34 27 36 77 3 107 l-23 22 -655 0 -656 0 -21 -23z" />{" "}
                </g>{" "}
              </svg>{" "}
              <h4>{LABELS.DRIVER}</h4>
            </MenuItem>
            {/* <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.VEHICLE_DRIVER);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.VEHICLE_DRIVER}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.LEAVES);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.LEAVES}</h4>
            </MenuItem>
            <MenuItem
              className="dashboardMenu"
              onClick={() => {
                setDashMenu(LABELS.LEAVE_TYPE);
              }}
            >
              <img src={chartProgressCurve} />
              <h4>{LABELS.LEAVE_TYPE}</h4>
            </MenuItem> */}
          </MenuList>
        </div>
      )}

      {dashMenu == LABELS.CITY && (
        <City
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.AREA && (
        <Area
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.CURRENCY && (
        <Currency
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.REGION && (
        <Region
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.TAX && (
        <Tax
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.CATEGORY && (
        <Category
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.PRODUCT && (
        <Product
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.REPORT1 && (
        <Report1
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.COUNTRY && (
        <Country
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.DISTRICT && (
        <District
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.STATE && (
        <State
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.ORGANIZATION_PROFILE && (
        <OrganizationProfile
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.CENTRAL_ZONES && (
        <CentralZone
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.STOCK_LEVEL && (
        <StockLevel
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.REGIONAL_ZONES && (
        <RegionalZone
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.BEAT && (
        <Beat
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.GRAMS && (
        <Grams
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.SKU && (
        <SKU
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.SUB_CATEGORY && (
        <SubCategory
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.NEW_CATEGORY && (
        <NewCategory
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.PRICE && (
        <Price
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.BRANCH && (
        <Branch
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.HOLIDAYS && (
        <Holidays
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.USERS && (
        <Users
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.TYPE_CATEGORY && (
        <ProductTypeCategory
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.MAIN_CATEGORY && (
        <MainCategory
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.LEAD_APPROVALS && (
        <LeadApprovals
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.LEAD_DOCUMENTS && (
        <LeadDocuments
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.VEHICLE && (
        <Vehicle
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {/* {dashMenu == LABELS.PRICE && <Price setDashMenu={setDashMenu} />} */}
      {/* {dashMenu == LABELS.BRANCH && <Branch setDashMenu={setDashMenu} />} */}
      {dashMenu == LABELS.FARE_CHART && (
        <FareChart
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.TEAM && (
        <Team
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.VEHICLE_DRIVER && (
        <VehicleDriver
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.SCHEME && (
        <Scheme
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {/* {dashMenu == LABELS.HOLIDAYS && <Holidays setDashMenu={setDashMenu} />} */}
      {/* {dashMenu == LABELS.USER && <Users setDashMenu={setDashMenu} />} */}
      {dashMenu == LABELS.LEAVES && (
        <Leaves
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.DRIVER && (
        <Driver
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.TARGETS && (
        <Targets
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}

      {dashMenu == LABELS.CUSTOMER && (
        <Customer
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.EXPENSES && (
        <Expenses
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.BUSINESS_CATEGORY && (
        <BusinessCategory
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
      {dashMenu == LABELS.SALES_WISE_CATEGORY && (
        <SalesWiseCategory
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}

      {dashMenu == LABELS.ASSIGN_BEAT && (
        <AssignBeat
          setDashMenu={(menu) => {
            if (menu === "") {
              setPageMenu(LABELS.HOME);
            } else {
              setDashMenu(menu);
            }
          }}
        />
      )}
    </React.Fragment>
  );
};

export default Masters;
